/* eslint-disable quote-props */
import React from "react";
import { FormControlLabel, FormControlLabelProps, styled } from "@mui/material";


interface StyledFormControlLabelProps extends FormControlLabelProps {
  checked: boolean;
}

const StyledFormControlLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme }) => ({
  textAlign: "center",
  margin: "0 8px 8px 0",
  "& .MuiCheckbox-root + .MuiTypography-root": {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "transparent",
    borderRadius: "24px",
    padding: "5px 16px",
    backgroundColor: "#fff",
  },
  "& .MuiCheckbox-root.Mui-checked + .MuiTypography-root": {
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.primary.main,
  },
  "& .MuiCheckbox-root.Mui-disabled + .MuiTypography-root": {
    backgroundColor: "#ffffff80",
    borderColor: "transparent",
  },
  "& .MuiCheckbox-root": {
    display: "none",
  },
}));

const MyFormControlWhiteLabel = (props: FormControlLabelProps) => {
  return <StyledFormControlLabel checked={props.checked as boolean} {...props} />;
};

export default MyFormControlWhiteLabel;
